package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.common.ui.components.TopBar
import com.yogaaicoach.dashboardViewModel
import com.yogaaicoach.user.AppViewModel
import react.ChildrenBuilder
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import react.useEffectOnce
import react.useState
import web.cssom.ClassName
import web.events.EventHandler
import web.location.location
import web.window.window

internal const val UpdateTrainingHash = "#update-training"
internal const val UpdateTrainingGoalHash = "#update-training-goal"
internal const val UpdateTrainingLevelHash = "#update-training-level"
internal const val UpdateTrainingAgeGroupHash = "#update-training-age-group"
internal const val UpdateTrainingScheduleHash = "#update-training-schedule"

internal external interface UpdateTrainingFlowPageProps : Props {
    var viewModel: UpdateTrainingViewModel
    var appViewModel: AppViewModel
    var route: String
    var navigateTo: (String) -> Unit
    var navigateReplacing: (String) -> Unit
    var onNavigateToPayment: () -> Unit
    var onNavigateToContactUs: () -> Unit
}

internal val UpdateTrainingFlowPage = FC<UpdateTrainingFlowPageProps> { props ->
    val vm = props.viewModel
    dashboardViewModel.dashboardData.value?.trainingProgram?.let { vm.initSelected(it) }

    var showQuitDialog by useState(false)

    useEffectOnce {
        window.onpopstate = EventHandler {
            val newHash = location.hash
            if (!newHash.startsWith("#update-training") && vm.hasChanges.value) {
                location.hash = "update-training"
                showQuitDialog = true
            }
        }
    }

    TopBar {
        title = when (props.route) {
            UpdateTrainingGoalHash -> "Update Goals"
            UpdateTrainingLevelHash -> "Update Level"
            UpdateTrainingAgeGroupHash -> "Update Age Group"
            UpdateTrainingScheduleHash -> "Update Schedule"
            else -> "Update Training Program"
        }
        onSignOut = { props.appViewModel.signOut() }
        onNavigateToDashboard = { props.navigateTo("") }
        onNavigateToPayment = props.onNavigateToPayment
        onNavigateToContactUs = props.onNavigateToContactUs
    }

    val onDone: () -> Unit = { props.navigateTo(UpdateTrainingHash) }

    when (props.route) {
        UpdateTrainingGoalHash -> UpdateGoalPage {
            viewModel = vm
            this.onDone = onDone
        }
        UpdateTrainingLevelHash -> UpdateLevelPage {
            viewModel = vm
            this.onDone = onDone
        }
        UpdateTrainingAgeGroupHash -> UpdateAgeGroupPage {
            viewModel = vm
            this.onDone = onDone
        }
        UpdateTrainingScheduleHash -> UpdateSchedulePage {
            viewModel = vm
            this.onDone = onDone
        }
        else -> UpdateTrainingMainPage {
            viewModel = vm
            onEditGoals = { props.navigateTo(UpdateTrainingGoalHash) }
            onEditLevel = { props.navigateTo(UpdateTrainingLevelHash) }
            onEditAgeGroup = { props.navigateTo(UpdateTrainingAgeGroupHash) }
            onEditSchedule = { props.navigateTo(UpdateTrainingScheduleHash) }
            onSaveDone = {
                vm.reset()
                dashboardViewModel.loadPage(props.appViewModel::askNewToken, isReload = true)
                props.navigateTo("")
            }
        }
    }

    if (showQuitDialog) {
        UnsavedChangesDialog(
            onLeave = {
                showQuitDialog = false
                vm.reset()
                props.navigateTo("")
            },
            onStay = { showQuitDialog = false },
        )
    }
}

private fun ChildrenBuilder.UnsavedChangesDialog(onLeave: () -> Unit, onStay: () -> Unit) {
    div {
        className = ClassName("dialog-backdrop")
        onClick = { onStay() }
        div {
            className = ClassName("dialog-box")
            onClick = { event -> event.stopPropagation() }
            h2 { className = ClassName("dialog-title"); +"Unsaved changes" }
            p { className = ClassName("dialog-body"); +"You have unsaved changes. Are you sure you want to leave this page?" }
            div {
                className = ClassName("dialog-button-row")
                button { className = ClassName("text-button"); +"Stay"; onClick = { onStay() } }
                button { className = ClassName("text-button"); +"Leave"; onClick = { onLeave() } }
            }
        }
    }
}
